<template>
  <div class="release-details">
    <div class="release-details-container">
      <div class="title">基本信息</div>
      <div class="row">
        <div>
          <label>任务名称：</label>
          <span>{{taskName}}</span>
        </div>
        <div>
          <label>状态：</label>
          <span>{{statusVal}}</span>
        </div>
        <div>
          <label>发布时间：</label>
          <span>{{createTime}}</span>
        </div>
      </div>
      <div class="row">
        <div>
          <label>执行人：</label>
          <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
            <div slot="content">
              <span v-for="(item, index) in executorList" :key="index">
                <span style="display:inline-block; margin: 0px 8px 4px 0px;">
                  {{item.name}}({{item.deptName}});
                </span>
                <br v-if="(index+1)%2==0"/>
              </span>
            </div>
            <span class="executor" ref="refExecutorTooltip" @mouseover="onMouseOver(`refExecutorTooltip`, executorList.length, 'refExecutorTooltip', executorList)">{{executor}}</span>
          </el-tooltip>
        </div>
        <div>
          <label>主要负责人：</label>
          <span>{{director}}</span>
        </div>
        <div>
          <label>风险责任主体单位：</label>
          <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
            <div slot="content">
              <span v-for="(item, index) in riskCompanyList" :key="index">
                <span style="display:inline-block; margin: 0px 8px 4px 0px;">
                  {{item.deptName}}({{item.name}});
                </span>
                <br v-if="(index+1)%2==0"/>
              </span>
            </div>
            <span class="executor" ref="refRiskCompanyTooltip" @mouseover="onMouseOver(`refRiskCompanyTooltip`, riskCompanyList.length, 'refExecutorTooltip', riskCompanyList)">{{riskCompany}}</span>
          </el-tooltip>
        </div>
      </div>
      <div class="border"></div>
      <div class="title">风险内容</div>
      <div class="table" v-if="tableData.length > 0">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="风险名称" min-width="200">
            <template slot-scope="scope">
              <div :class="scope.row.status == 'HIGH' ? 'high-risk': scope.row.status =='MIDDLE'?'medium-risk':'low-risk'">
                {{scope.row.riskName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="风险细项" min-width="260">
            <template slot-scope="scope">
              <el-tooltip v-if="!isShowTableTooltip" class="item" effect="dark" placement="top-start">
                <div slot="content">
                  <span v-for="(item, index) in scope.row.riskDetails" :key="index">
                    <span style="display:inline-block;">
                      {{item}}
                    </span>
                    <br v-if="(index+1)%20==0"/>
                  </span>
                </div>
                <div>
                  <span :ref="`refRiskTooltip${scope.$index}`" @mouseover="onMouseOverTable(`refRiskTooltip${scope.$index}`)">
                    {{scope.row.riskDetails}}
                  </span>
                </div>
              </el-tooltip>
              
              <div v-else>
                <span :ref="`refRiskTooltip${scope.$index}`" @mouseover="onMouseOverTable(`refRiskTooltip${scope.$index}`)">
                  {{scope.row.riskDetails}}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="评分标准" prop="scoringCriteria" min-width="200">
          </el-table-column>
          <el-table-column label="扣分规制" prop="deductionRegulation" min-width="250" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="btn-text"
                @click="lookDetails(scope.row.id)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-tpl-container">
          <pagination-tpl
            :total="totalNum"
            :currentPage="currentPage"
            @queryChange="onQueryChange"
          ></pagination-tpl>
        </div>
      </div>
      <div class="nothing" v-if="tableData.length == 0">
        <div>
          <div>
            <img src="../../../../assets/nothing.png">
          </div>
          <p>暂无数据</p>
        </div>
      </div>
    </div>
    
    <!-- 查看详情 -->
    <el-dialog
      title="查看详情"
      class="look-details"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="details-row">
        <div>
          <label>风险名称：</label>
          <div class="details-content">{{ riskName }}</div>
        </div>
        <div>
          <label>评分标准：</label>
          <div class="details-content">{{ scoringCriteria }}</div>
        </div>
      </div>
      <div class="details-row">
        <div>
          <label>风险细项：</label>
          <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
            <div slot="content">
              <span v-for="(item, index) in riskDetails" :key="index">
                <span style="display:inline-block;">
                  {{item}}
                </span>
                <br v-if="(index+1)%20==0"/>
              </span>
            </div>
            <span class="details-content" ref="refRiskDetailsTooltip" @mouseover="onMouseOver(`refRiskDetailsTooltip`, riskDetails.length)">{{riskDetails}}</span>
          </el-tooltip>
        </div>
        <div>
          <label>扣分规则：</label>
          <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!isShowTooltip">
            <div slot="content">
              <span v-for="(item, index) in deductionRegulation" :key="index">
                <span style="display:inline-block;">
                  {{item}}
                </span>
                <br v-if="(index+1)%20==0"/>
              </span>
            </div>
            <span class="details-content" ref="refDeductionRegulationTooltip" @mouseover="onMouseOver(`refDeductionRegulationTooltip`, deductionRegulation.length)">{{deductionRegulation}}</span>
          </el-tooltip>
        </div>
      </div>
    <div class="table">
      <el-table :data="tableList" style="width: 100%" height="400px">
        <el-table-column label="风险责任主体单位">
          <template slot-scope="scope">
            <div>
              {{scope.row.deptName}}({{scope.row.name}})
            </div>
          </template>
        </el-table-column>
        <el-table-column label="风险情况">
          <template slot-scope="scope">
            <div class="points-info">
              <p>{{scope.row.surplusPoints}}</p>
              <p class="deductPoints">({{scope.row.deductPoints}})</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark"></el-table-column>
        <el-table-column label="状态" prop="statusVal"></el-table-column>
      </el-table>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import { formatTimeToDate, handleAmount } from "@/common/js/utils.js"
import { statusMixins } from '@/common/mixins/status/status.js'
import Risk from "@/models/risk.js";
export default {
  mixins: [statusMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      id: '',
      totalNum: 0,
      currentPage: 1,
      taskName: '',
      statusVal: '',
      createTime: '',
      executor: '',
      director: '',
      riskCompany: '',
      executorList: [],
      riskCompanyList: [],
      tableData: [],
      isShowTooltip: false,
      isShowTableTooltip: true,
      dialogVisible: false,
      riskName: '',
      scoringCriteria: '',
      riskDetails: '',
      deductionRegulation: '',
      tableList: [],
    }
  },

  created() {
    config()
    this.id = this.$route.query.id
    this.initRiskContent()
    this.initBaseInfo()
  },

  methods: {
    onMouseOver(str,length, type, arr) {
      let itemFontSize = 14
      let contentWidth = this.$refs[str].offsetWidth;
      let textAllWidth
      if (type !== 'refExecutorTooltip') {
        textAllWidth = (length*itemFontSize) - contentWidth*2
      } else {
        let nums = 0
        arr.map(i => {
          let newStr = `${i.name}(${i.deptName});`
          nums += newStr.length
        })
        textAllWidth = (nums*itemFontSize) - contentWidth*2
      }
      // 判断是否开启tooltip功能
      if (textAllWidth > 0) {
        this.isShowTooltip = true;
      } else {
        this.isShowTooltip = false;
      }
    },

    onMouseOverTable(str) {
      const tag = this.$refs[str]
      // 获取父级元素的可视高度
      const parentHeight = tag.parentNode.offsetHeight
      // 获取元素的可视高度
      const contentHieght = tag.offsetHeight
      this.isShowTableTooltip = contentHieght <= parentHeight
    },

    initBaseInfo() {
      let id = this.id
      Risk.getRiskReleaseBaseInfo(id).then(res => {
        if (res.success) {
          let {publishTime, status, taskName, riskResponsibilityEntity, riskImplementEntityList, riskMainUnitEntityList} = res.result
          this.taskName = taskName
          this.statusVal = this.RISK_RELEASE_STATUS[status]
          this.createTime = formatTimeToDate(publishTime)
          let executorStr = ''
          let executorList = []
          riskImplementEntityList.map(i => {
            let str = `${i.userName}（${i.deptName}）；`
            executorStr += str
            let obj = {}
            obj.name = i.userName
            obj.deptName = i.deptName
            executorList.push(obj)
          })
          this.executor = executorStr
          this.executorList = executorList

          let directorStr = ''
          // riskResponsibilityEntity.map(i => {
            let str = `${riskResponsibilityEntity.userName}（${riskResponsibilityEntity.deptName}）；`
            directorStr += str
          // })
          this.director = directorStr

          let riskCompanyStr = ''
          let riskCompanyList = []
          riskMainUnitEntityList.map(i => {
            let str = `${i.deptName}（${i.userName}）；`
            riskCompanyStr += str
            let obj = {}
            obj.name = i.userName
            obj.deptName = i.deptName
            riskCompanyList.push(obj)
          })
          this.riskCompany = riskCompanyStr
          this.riskCompanyList = riskCompanyList
        } else {
          this.$message.error(res.message)
        }
      })
    },

    initRiskContent() {
      let riskTaskId = this.id
      let pageNo = this.currentPage
      let data = {
        riskTaskId,
        pageNo
      }
      Risk.getRiskReleaseContentList(data).then(res => {
        if (res.success) {
          let {totalNum, items} = res.result
          this.totalNum = totalNum
          let arr = []
          items.map(i => {
            let obj = {}
            obj.id = i.riskTaskItemId
            obj.status = i.level
            obj.riskDetails = i.riskContent
            obj.riskName = i.riskName
            obj.scoringCriteria = i.standard
            obj.deductionRegulation = ''
            i.pointList.map(v => {
              let point = handleAmount(v,2).toString()
              obj.deductionRegulation += `${point}；`
            })
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    initRiskReleaseDirectorDetails(id) {
      Risk.getRiskReleaseDirectorDetails(id).then(res => {
        if (res.success) {
          let { riskName, standard, riskContent, pointList} = res.result
          this.riskName = riskName
          this.scoringCriteria = standard
          this.riskDetails = riskContent
          let deductionRegulationStr = ''
          pointList.map(v => {
            let points = handleAmount(v,2).toString()
            deductionRegulationStr += `${points}；`
          })
          this.deductionRegulation = deductionRegulationStr
        } else {
          this.$message.error(res.message)
        }
      })
    },

    initRiskCompanyDetails(id) {
      Risk.getRiskReleaseRiskCompanyList(id).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.status = i.status
            obj.statusVal = this.RISK_APPROVAL_STATUS[i.status]
            obj.name = i.mainUnitName
            obj.deptName = i.groupName
            obj.remark = i.remark
            obj.deductPoints = handleAmount(i.deducted,2)
            obj.surplusPoints = handleAmount(i.point,2)
            arr.push(obj)
          })
          this.tableList = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initRiskContent();
    },

    lookDetails(id) {
      this.initRiskReleaseDirectorDetails(id)
      this.initRiskCompanyDetails(id)
      this.dialogVisible = true
    },

    handleClose() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang='scss'>
.release-details {
  flex: 1;
  padding: 21px 24px;
  background: $bg-white;
  .release-details-container {
    height: 100%;
  }
  .title {
    text-align: left;
    padding-left: 10px;
    font-weight: bold;
    font-size: $fs-medium-s;
    color: $color-BlackGrey;
    border-left: 4px solid $color-DeepReddishBlue;
  }
  .row {
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    @include flex-start;
    align-items: flex-start;
    margin-top: 25px;
    div {
      width: 33.33%;
      line-height: 20px;
      @include flex-start;
      align-items: flex-start;
      .executor {
        flex: 1;
        text-align: left;
        @include two-wrap-ellipsis();
      }
    }
  }
  .border {
    width: 100%;
    height: 1px;
    background: $bg-ShallowLightSnow;
    margin: 24px 0px;
  }
  .table {
    margin-top: 20px;
  }
  .look-details {
    .el-dialog {
      width: 840px;
    }
  }
  .nothing {
    position: absolute;
    left: 60%;
    top: 50%;
    transform: translate(0%,-50%);
    img {
      width: 157px;
      height: 157px;
    }
    p {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 24px;
    }
  }
  .high-risk {
    @include border-left(3px, 30px, $high-risk, -16px, 50%)
  }
  .medium-risk {
    @include border-left(3px, 30px, $medium-risk, -16px, 50%)
  }
  .low-risk {
    @include border-left(3px, 30px, $low-risk, -16px, 50%)
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
    line-height: 22px;
    @include two-wrap-ellipsis();
  }
  .el-dialog__body {
    padding: 0px 20px 20px 20px;
  }
  .details-row{
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    @include flex-start;
    align-items: flex-start;
    margin-top: 20px;
    div {
      width: 50%;
      line-height: 20px;
      @include flex-start;
      align-items: flex-start;
      .details-content {
        flex: 1;
        text-align: left;
        @include two-wrap-ellipsis();
      }
    }
  }
  .points-info {
    @include flex-start;
    .deductPoints {
      color: $color-PhoneStar;
      margin-left: 6px;
    }
  }
}
</style>
